import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_layered_bar_with_value = _resolveComponent("layered-bar-with-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_hug_value = _resolveComponent("hug-value");
  return _openBlock(), _createBlock(_component_hug_value, {
    loading: $props.loading,
    class: "bsr-evolution-bar-with-value"
  }, {
    default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
      gap: 8
    }, {
      evolution: _withCtx(() => [_renderSlot(_ctx.$slots, "evolution")]),
      default: _withCtx(() => [_createVNode(_component_layered_bar_with_value, {
        align: "left",
        value1: $props.value,
        value2: $props.max,
        min1: $props.min,
        max1: $props.max,
        min2: $props.min,
        max2: $props.max,
        color1: $data.color1,
        color2: $data.color2,
        style: {
          padding: 0
        }
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        layers: _withCtx(() => [_createVNode(_component_variable_styled_bar, {
          value: $props.max,
          color: $data.color1,
          min: $props.min,
          max: $props.max
        }, null, 8, ["value", "color", "min", "max"]), _createVNode(_component_variable_styled_bar, {
          value: $options.transformedValue,
          color: $data.color2,
          min: $props.min,
          max: $props.max
        }, null, 8, ["value", "color", "min", "max"])]),
        _: 3
      }, 8, ["value1", "value2", "min1", "max1", "min2", "max2", "color1", "color2"])]),
      _: 3
    })]),
    _: 3
  }, 8, ["loading"]);
}